<div class="home-container view">
    <div *ngIf="loadingAvailability" class="home-container__status">
        Cargando disponibilidad de fechas...
    </div>
    <div *ngIf="availabilityError" class="home-container__status home-container__status--error">
        {{ availabilityError }}
    </div>

    <div class="home-container__year">
        <button *ngFor="let yearItem of years" class="btn btn-primary" [class.active]="year === yearItem"
            (click)="selectYear(yearItem)">
            {{ yearItem }}
        </button>
    </div>

    <div *ngIf="year" class="home-container__month">
        <button *ngFor="let monthItem of months" class="btn btn-secondary" [class.active]="month === monthItem"
            (click)="selectMonth(monthItem)">
            {{ 'date.' + (monthItem - 1) | transloco }}
        </button>
    </div>

    <div *ngIf="year && month && days.length > 0" class="home-container__day">
        <button class="btn btn-secondary" [class.active]="!day" (click)="clearDaySelection()" style="min-width: 162px;">
            {{ 'home.full-month' | transloco }}
        </button>
        <button *ngFor="let dayItem of days" class="btn btn-secondary" [class.active]="day === dayItem"
            (click)="selectDay(dayItem)">
            {{ dayItem }}
        </button>
    </div>

    <div *ngIf="granularity" class="home-container__granularity">
        {{ 'home.selected-granularity' | transloco:{ granularity: ('granularity.' + granularity) | transloco } }}
    </div>

    <div *ngIf="year && month" class="home-container__views">
        <button *ngFor="let contentType of topLevelContentTypes" class="btn btn-secondary"
            (click)="goToChartsByContentType(contentType)">
            {{ getStructureTypeLabel(contentType) }}
        </button>

        <span *ngIf="topLevelContentTypes.length > 0" class="home-container__views__separator" aria-hidden="true"></span>

        <button class="btn btn-secondary" (click)="goTo('users')">{{ 'users.title' | transloco }}</button>
        <button class="btn btn-secondary" (click)="goTo('devices')">{{ 'devices.title' | transloco }}</button>

        <span *ngIf="systemTypeViews.length > 0" class="home-container__views__separator" aria-hidden="true"></span>

        <button *ngFor="let sysType of systemTypeViews" class="btn btn-secondary"
            (click)="goToChartsByContentType(sysType)">
            {{ getStructureTypeLabel(sysType) }}
        </button>
    </div>
</div>
